import { render, staticRenderFns } from "./SelectPlataform.vue?vue&type=template&id=70df8a20"
import script from "./SelectPlataform.vue?vue&type=script&lang=js"
export * from "./SelectPlataform.vue?vue&type=script&lang=js"
import style0 from "./SelectPlataform.vue?vue&type=style&index=0&id=70df8a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports